import { render } from "./NutricionPlatoLink.vue?vue&type=template&id=ca03922c&scoped=true"
import script from "./NutricionPlatoLink.vue?vue&type=script&lang=js"
export * from "./NutricionPlatoLink.vue?vue&type=script&lang=js"

import "./NutricionPlatoLink.vue?vue&type=style&index=0&id=ca03922c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca03922c"]])

export default __exports__